export const kTaxCodeSearchPageUrl = 'https://taxcode.avatax.avalara.com/';
export const kTermsOfServiceUrl = 'https://popshoplive.com/terms-of-service/';
export const kCreatorTermsOfServiceUrl =
  'https://popshoplive.com/creator-terms-of-service/';
export const kPrivacyPolicyUrl = 'https://popshoplive.com/privacy-policy/';
export const kFAQsUrl = 'https://popshoplive.com/faq/';
export const kCareersUrl = 'https://popshoplive.com/';
export const kCommunityGuidelinesUrl =
  'https://popshoplive.com/community-guidelines/';

export const kUserCategoryCountMin = 3;
export const kUserCategoryCountMax = 10;
export const kSellerCategoryCountMin = 1;
export const kSellerCategoryCountMax = 3;
export const kMinStoresToFollow = 5;
export const kPrivateEmailPlaceholder = 'private@popshop.live';
export const kDefaultMaxStoreFavoriteListingLimit = 25;
export const kStorefrontHowToUrl = 'https://popshoplive.com/how-to';

export const kBrandName = 'Popshoplive';
